import styled from '@emotion/styled';
import { css } from 'emotion';

export const MediaPreviewContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
`;

export const MediaPreviewPlayerWrapper = styled.div`
  padding: 20px 16px 0px 16px;
  text-align: left;
`;

export const VideoDisclaimerWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 50px;
  border-top: 1px solid #dedfe0;
  color: #7f8287;
  font-size: 1.6rem;
  line-height: 19px;
  text-align: center;
  @media (max-width: 600px) {
    font-size: 1.3rem;
  }
`;

export const uploaderEditEpisodeButtonStyle = css`
  width: 200px;
  height: 40px;
  margin-left: 12px;
  color: #5000b9;
  text-align: center;
  @media (max-width: 600px) {
    width: 50%;
  }
`;

/** Multi-audio file styles */

export const MultiFileProgressBarContainer = styled.div`
  display: flex;
  margin: 14px 0;
  border-radius: 4px;
  overflow: hidden;
  background: #f4f4f4;
`;

export const MultiFileProgressBarStep = styled.div`
  display: flex;
  border-radius: 4px;
  overflow: hidden;
`;
